console.log("Contact form JS file");

const successText = document.querySelector(".formSuccess");
const failureText = document.querySelector(".formFailure");
const submitBtn = document.querySelector("#submitBtn");

window.addEventListener( "load", function () {
    console.log("window ready");
    function sendData() {

        successText.style.display = "none";
        failureText.style.display = "none";

        const XHR = new XMLHttpRequest();

        // Bind the FormData object and the form element
        const FD = new FormData( form );

        // Define what happens on successful data submission
        XHR.addEventListener( "load", function(event) {
            if ( event.target.responseText == "200" ){
                successText.style.display = "initial";
            }else{
                failureText.style.display = "initial";
            }
            submitBtn.setAttribute("disabled", true);
        } );

        // Define what happens in case of error
        XHR.addEventListener( "error", function( event ) {
            failureText.style.display = "initial";
            submitBtn.setAttribute("disabled", true);
        } );

        // Set up our request
        XHR.open( "POST", "/assets/php/formSubmit.php" );

        // The data sent is what the user provided in the form
        XHR.send( FD );
    }

    // Access the form element...
    const form = document.getElementById( "contactform" );
    console.log(form);

    // ...and take over its submit event.
    form.addEventListener( "submit", function ( event ) {
        console.log("Submitted");
        event.preventDefault();

        sendData();
    });
} );